import { zipSync, strToU8 } from 'fflate'
import type { BundleResult } from './api.ts'
import type { Brand } from '../brand/BrandKitContext.tsx'
import { buildDocHtml, renderPrintBlanks } from './export.ts'
import { renderMarkdown } from './markdown.ts'

export function bundleFilename(result: BundleResult): string {
  const base = result.topic.title.replace(/[^A-Za-z0-9]+/g, '-').replace(/^-|-$/g, '')
  return `${base}${result.anyDraft ? '-DRAFT' : ''}.zip`
}

/**
 * Zips server-rendered documents client-side, so the Worker needs no zip
 * dependency. `doc.markdown` already carries the draft notice for unapproved
 * content — the server bakes it in via `withDraftNotice` on every render and
 * bundle path — so this must not pass a second copy to `buildDocHtml`. Doing
 * so once printed the notice twice in a downloaded draft.
 */
export function buildBundleZip(result: BundleResult, brand: Brand): Uint8Array<ArrayBuffer> {
  const files: Record<string, Uint8Array> = {}
  for (const doc of result.documents) {
    const body = renderPrintBlanks(renderMarkdown(doc.markdown))
    files[doc.filename] = strToU8(buildDocHtml(brand, body))
  }
  return zipSync(files)
}

export async function downloadBundleZip(result: BundleResult, brand: Brand): Promise<void> {
  const blob = new Blob([buildBundleZip(result, brand)], { type: 'application/zip' })
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = bundleFilename(result)
  a.click()
  URL.revokeObjectURL(url)
}
